"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThreeDStructureConnect = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _actions = require("../../../redux/actions");
var _ThreeDStructureContent = require("./ThreeDStructureContent");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ThreeDStructureConnect = props => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const firstEffect = (0, _react.useRef)(true);
  /** @todo add selector to the core */
  const coreDevices = (0, _reactRedux.useSelector)(store => {
    var _store$constants$pack;
    return ((_store$constants$pack = store[_paulCorePackage.constants.packageKey]) === null || _store$constants$pack === void 0 ? void 0 : _store$constants$pack.devices) || {};
  });
  (0, _react.useEffect)(() => {
    if (firstEffect.current && coreDevices !== null && coreDevices !== void 0 && coreDevices.hasData) {
      firstEffect.current = false;
      dispatch((0, _actions.setInitialDeviceData)({
        result: coreDevices
      }));
    }
  }, [dispatch, coreDevices]);

  /** This is necessary because in this function we get coreDevices
   * to enter the initial values in the redux package,
   * in case the component is loaded after the data request */
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_ThreeDStructureContent.ThreeDStructureContent, props), [props]);
};
exports.ThreeDStructureConnect = ThreeDStructureConnect;